import { createClient } from '@/lib/supabase/client';

export async function getAccessToken() {
  const supabase = createClient();
  const { data, error } = await supabase.auth.getSession();

  if (error) {
    throw new Error(error.message || 'No active Supabase session');
  }

  const accessToken = data?.session?.access_token;
  if (!accessToken) {
    throw new Error('No active Supabase session');
  }

  return accessToken;
}
